/* Logo Slider section 
--------------------------------------*/

// import Swiper from "../vendors/swiper";

class LogoSlider {
  constructor (parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.slider();
  }

  slider = () => {
    let sliders = qsa('.logo-slider-js');
    sliders?.forEach(element => {
      let featuredSliderSectionId = element.dataset.id;
      let featuredSliderSlide = element.dataset.slide;
      let featuredSliderClass = `.logo-slider-js.${featuredSliderSectionId}`;
      this.LogoSlider(featuredSliderClass,featuredSliderSlide);

    });
  }
  LogoSlider = (sliderClass,featuredSliderSlide) => {
    let activeSlide = true;
    if (window.innerWidth > 767) {
      if (!qs(sliderClass).classList.contains('slider-active-js')) {
        activeSlide = false;
      }
    }
    if (activeSlide) {
      const recommendationSlider = new Swiper(sliderClass, {
        slidesPerView: featuredSliderSlide,
        slidesPerGroup: 1,
        shortSwipes: true,
        shortSwipesRatio: 0,
        speed: 1000,
        resistanceRatio:0.4,
        spaceBetween: 10,
        oopFillGroupWithBlank: false,
        // Pagination dots
        pagination: {
          el: `.swiper-pagination.logo-pagination`,
          type: 'bullets',
          clickable : true
        },
        breakpoints: {
          1: {
            slidesPerView: 1.90,
            spaceBetween: 10,
            resizeReInit: true,
            pagination:false,
            navigation:false,
          },
          768: {
            slidesPerView: 3.90,
            resizeReInit: true,
            spaceBetween: 10,
            pagination:false,
            navigation:false,
          },
          1024: {
            slidesPerView: featuredSliderSlide,
          },
        },
      });
    }
  }

}

new LogoSlider(qs('.logo-slider-js'));
